/* Extracted from BulkSimilarityPage.jsx — see git log for history. */
import React from 'react';
import { toast } from 'sonner';
import { GitMerge } from 'lucide-react';
// Small inline chip rendered on rows that are sources of a TRANSITIVE merge
// chain. Shows "→ Row N" (or "→ approved Q") so admins see the eventual
// landing while they're still picking targets — not just at Apply time.
// Clickable: jumps focus to the destination row with a brief amber pulse
// (for staging targets) or shows a toast (for approved targets, since
// approved rows aren't rendered in the triage page).
const ChainLandingChip = ({ hint, allRowsById, stagingId, jumpToRow }) => {
  const isApproved = hint.finalTargetSource === 'approved';
  const targetRow = !isApproved && allRowsById ? allRowsById[hint.finalTarget] : null;
  const label = isApproved
    ? `Approved Q (${(hint.finalTarget || '').slice(0, 16)}…)`
    : (targetRow ? `Row ${targetRow.row_number}` : '(unknown target)');
  const canJump = !isApproved && !!targetRow;

  const handleClick = (e) => {
    e.stopPropagation(); // don't trigger row-card onClick (focus side-effect)
    if (canJump) {
      jumpToRow?.(hint.finalTarget);
    } else if (isApproved) {
      toast.info('Final target is an approved question — not visible in the triage view.');
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={!canJump && !isApproved}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded border text-[9px] bg-amber-50 text-amber-800 border-amber-300 ${canJump ? 'hover:bg-amber-100 hover:border-amber-400 cursor-pointer' : 'cursor-default'} transition-colors`}
      title={canJump
        ? `Click to jump to ${label}. This row's sittings will ultimately land there (${hint.hops} hop${hint.hops !== 1 ? 's' : ''}).`
        : `This row participates in a merge chain (${hint.hops} hop${hint.hops !== 1 ? 's' : ''}). All sittings will land in ${label}.`}
      data-testid={`chain-landing-chip-${stagingId}`}
    >
      <GitMerge className="w-2.5 h-2.5" />
      Lands in {label}
    </button>
  );
};

export default ChainLandingChip;
